const BASE_URL =  'https://cassuss.com'

export default () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Cassuss E-commerce",
  "url": BASE_URL,
  "inLanguage": "fr",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${BASE_URL}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
})
